function VimeoPlayers(holderClass){

    var players =[];
    var buttons =[];

    $(holderClass).each(function( index ) {

        var id = $(this);

        var iframeId = "#" + $(".embed-container iframe", $(this)).attr('id');

        console.log("id " + iframeId);

        var iframe = $(iframeId)[0],
            player = $(iframe),
            status = $('.status');
        $play = $('.button-play', $(this));

        players.push(player);
        buttons.push($play);

// When the player is ready, add listeners for pause, finish, and playProgress
        player.addEvent('ready', function() {
            //status.text('ready');

            //player.addEvent('pause', onPause);
            //player.addEvent('finish', onFinish);
            //player.addEvent('playProgress', onPlayProgress);
        });

// Call the API when a button is pressed
        $play.bind('click', function() {
            // console.log("play pressed");

            for (var i=0; i<players.length; i++){

                TweenMax.set(buttons[i], {autoAlpha:1});
                players[i].api("pause");

            }

            TweenMax.set($(this), {autoAlpha:0});

            setTimeout(function (e){


                //    console.log("played");

                player.api("play");

            }, 200);


            // setTimout()


        });

        //function onPause(id) {
        // status.text('paused');
        //}

        // function onFinish(id) {
        //     status.text('finished');
        //}

        // function onPlayProgress(data, id) {
        //   status.text(data.seconds + 's played');
        //}

    });

}



